@if (initialized) {
  <nz-spin [nzSpinning]="loading">
    <div>
      <form nz-form [nzLayout]="'vertical'">
        <nz-form-item>
          <nz-form-control>
            <nz-form-item>
              <nz-form-label nzRequired>Lietotājs, kura dati parādīsies izdrukā</nz-form-label>
              <nz-select nzPlaceHolder="Lietotājs" nzShowSearch [(ngModel)]="printoutDialogOptions.userId" [ngModelOptions]="{ standalone: true }">
                @for (user of users$ | async; track user.id) {
                  <nz-option
                    [nzLabel]="userToString(user)"
                    [nzValue]="user.id"
                  ></nz-option>
                }
              </nz-select>
            </nz-form-item>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-control>
            <nz-form-item>
              <nz-form-label nzRequired>Izdrukas veidne</nz-form-label>
              <nz-select
                nzPlaceHolder="Izdrukas veidne"
                [(ngModel)]="printoutDialogOptions.printoutTemplateId"
                [ngModelOptions]="{ standalone: true }"
                >
                @for (t of printoutTemplates; track t.id) {
                  <nz-option [nzLabel]="t.name" [nzValue]="t.id"></nz-option>
                }
              </nz-select>
            </nz-form-item>
          </nz-form-control>
        </nz-form-item>
      </form>
    </div>
    <div *nzModalFooter>
      <button nz-button nzType="default" (click)="cancel()">Atcelt</button>
      <button nz-button nzType="primary" (click)="submitAndReturn()">Drukāt</button>
    </div>
  </nz-spin>
}
